// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2B7Jq","inquiryform":"styles_inquiryform__3fvrN","item":"styles_item__19gxz"};